export default "__VITE_ASSET__OUPF$eTt__"